import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "@/App";
import "@/i18n"; // side-effect: initialise i18next before first render
import "@/styles/index.css";

const container = document.getElementById("root");
if (!container) throw new Error("Root element #root not found");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
